exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addPropertyModal .modal-content{min-height:calc(100vh - 3.5rem)}.modal-body-sm .modal .modal-body{padding-top:1.5rem;padding-bottom:1.5rem}", ""]);

// exports
